/* ============================================
   HAEZEL TECH — Mobile Device Model Dropdown
   Version: 4.0
   Finds group where checkbox value = iPhone model
============================================ */

(function() {
  'use strict';

  var DEVICE_VALUES = ['iphone', 'samsung', 'ipad', 'airpods'];

  function isDeviceValue(val) {
    if (!val) return false;
    var v = val.toLowerCase();
    return DEVICE_VALUES.some(function(d) { return v.indexOf(d) !== -1; });
  }

  function buildDeviceDropdown() {
    var filterForm = document.getElementById('FacetFiltersFormMobile');
    if (!filterForm) return;
    if (filterForm.querySelector('.ht-filter-dropdown-row')) return;

    var allDetails = filterForm.querySelectorAll('.mobile-facets__details');
    if (!allDetails.length) return;

    // Find Device Model group — the one whose checkboxes have iPhone/Samsung values
    var deviceDetail = null;
    allDetails.forEach(function(detail) {
      if (deviceDetail) return;
      var firstCb = detail.querySelector('input[type="checkbox"]');
      if (firstCb && isDeviceValue(firstCb.value)) {
        deviceDetail = detail;
      }
    });

    if (!deviceDetail) {
      console.log('HT: Device Model group not found. Groups found:', allDetails.length);
      // Debug — log all checkbox values
      allDetails.forEach(function(d, i) {
        var cb = d.querySelector('input[type="checkbox"]');
        console.log('Group', i, '— first checkbox value:', cb ? cb.value : 'none');
      });
      return;
    }

    var checkboxes = deviceDetail.querySelectorAll('input[type="checkbox"]');
    if (!checkboxes.length) return;

    // Build select
    var select = document.createElement('select');
    select.className = 'ht-filter-select';

    var defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = 'All models';
    select.appendChild(defaultOpt);

    var hasSelected = false;

    // Check URL for currently active filter
    var urlParams = new URLSearchParams(window.location.search);
    var activeFilter = urlParams.get('filter.v.option.size') || '';

    checkboxes.forEach(function(cb) {
      var opt = document.createElement('option');
      opt.value = cb.value;
      // Use clean value as label — it's already clean e.g. "iPhone 17 Pro Max"
      opt.textContent = cb.value;

      // Match against URL param (most reliable)
      if (activeFilter && cb.value === activeFilter) {
        opt.selected = true;
        hasSelected = true;
      }

      select.appendChild(opt);
    });

        // Pre-select iPhone 18 Pro Max if no active filter
    if (!hasSelected) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === 'iPhone 18 Pro Max') {
          select.selectedIndex = i;
          select.classList.add('ht-has-value');
          break;
        }
      }
    } else {
      select.classList.add('ht-has-value');
    }

    // On change — navigate to filtered URL
    select.addEventListener('change', function() {
      var val = this.value;
      this.classList.toggle('ht-has-value', !!val);

      // Build clean URL with selected filter
      var params = new URLSearchParams();

      // Keep sort if active
      var currentParams = new URLSearchParams(window.location.search);
      if (currentParams.get('sort_by')) {
        params.set('sort_by', currentParams.get('sort_by'));
      }

      // Set device model filter
      if (val) {
        params.set('filter.v.option.size', val);
      }

      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

      // Navigate — clean and reliable
      window.location.href = newUrl;
    });

    // Build wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'ht-filter-dropdown-row';

    var lbl = document.createElement('span');
    lbl.className = 'ht-filter-dropdown-label';
    lbl.textContent = 'Device Model';

    wrapper.appendChild(lbl);
    wrapper.appendChild(select);

    // Hide the original accordion group
    deviceDetail.style.display = 'none';

    // Insert at top of filter list
    var insertBefore = filterForm.querySelector('.mobile-facets__details, .mobile-facets__wrapper > *');
    if (insertBefore) {
      insertBefore.parentNode.insertBefore(wrapper, insertBefore);
    } else {
      filterForm.appendChild(wrapper);
    }

    console.log('HT: Device Model dropdown built with', checkboxes.length, 'options');
  }

  // MutationObserver — catch when filter drawer HTML is injected
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (!node.querySelector) return;
        if (node.id === 'FacetFiltersFormMobile' ||
            node.querySelector && node.querySelector('#FacetFiltersFormMobile')) {
          setTimeout(buildDeviceDropdown, 150);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Filter button click
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-facets__open, .facets__open, [data-target="FacetFiltersFormMobile"], .facets-container-drawer')) {
      setTimeout(buildDeviceDropdown, 300);
      setTimeout(buildDeviceDropdown, 700);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildDeviceDropdown);
  } else {
    buildDeviceDropdown();
  }

})();
